
export const APP_CONFIG = {
  AUTO_SAVE_TIMEOUT: 3000,
  NOTIFICATION_DURATION: 5000,
  MAX_FORM_FIELDS: 100,
  MAX_FORM_TITLE_LENGTH: 200,
};

export const API_CONFIG = {
  CSRF_COOKIE_NAME: 'csrftoken',
  CSRF_HEADER_NAME: 'X-CSRFToken',
  DEFAULT_API_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
};

export const UI_CONFIG = {
  FIELD_TYPES: [
    'text',
    'number',
    'phone',
    'email',
    'dropdown',
    'checkbox',
    'radio',
    'textarea',
    'date',
    'file',
    'image',
    'multi_row',
    'header',
    'checkbox_with_input',
    'logic'
  ] as const,

  HEADER_FONT_SIZES: ['small', 'medium', 'large'] as const,

  INPUT_TYPES: ['text', 'number'] as const,
};